export default __webpack_public_path__ + "static/media/vertical-split.742ff384.svg";